"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = exports.DateFormat = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var Input_1 = require("../Input/Input");
var utils_1 = require("./utils");
var DateFormat;
(function (DateFormat) {
    DateFormat["DMY"] = "dd/mm/yyyy";
    DateFormat["YMD"] = "yyyy/mm/dd";
    DateFormat["MDY"] = "mm/dd/yyyy";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var DateInput = function (_a) {
    var onChange = _a.onChange, value = _a.value, _b = _a.format, format = _b === void 0 ? "dd/mm/yyyy" : _b, _c = _a.delimiter, delimiter = _c === void 0 ? "/" : _c, maskModifier = _a.maskModifier, isValid = _a.isValid, htmlName = _a.htmlName, csx = _a.csx, wrapperSX = _a.wrapperSX, variant = _a.variant, children = _a.children, placeholder = _a.placeholder, rest = __rest(_a, ["onChange", "value", "format", "delimiter", "maskModifier", "isValid", "htmlName", "csx", "wrapperSX", "variant", "children", "placeholder"]);
    var t = react_i18next_1.useTranslation("jds").t;
    var datePartsLocalization = react_1.useMemo(function () { return ({
        dd: t("dateInput:dayPlaceholder", "dd"),
        mm: t("dateInput:monthPlaceholder", "mm"),
        yyyy: t("dateInput:yearPlaceholder", "yyyy"),
    }); }, [t]);
    var formatWithLocalization = react_1.useMemo(function () {
        return format
            .split("/")
            .reduce(function (acc, datePart) {
            acc.push(datePartsLocalization[datePart]);
            return acc;
        }, [])
            .join("/");
    }, [format, datePartsLocalization]);
    var formatWithCustomDelimiter = react_1.useMemo(function () {
        return delimiter === "/"
            ? formatWithLocalization
            : formatWithLocalization.split("/").join(delimiter);
    }, [delimiter, formatWithLocalization]);
    var onChangeWithValidation = react_1.useCallback(function (event) {
        var value = event.target.value;
        var isFilled = value !== "" && !value.split("").some(utils_1.isLowAlpha);
        var date = isFilled ? utils_1.buildDate(value, format) : null;
        if (onChange) {
            onChange(event, date);
        }
    }, [format, onChange]);
    return (react_1.default.createElement(react_input_mask_1.default, __assign({ mask: utils_1.formatToMask(formatWithCustomDelimiter), maskPlaceholder: utils_1.modifyMask(formatWithCustomDelimiter, maskModifier), onChange: onChangeWithValidation, value: value }, rest),
        react_1.default.createElement(Input_1.Input, { isValid: isValid, htmlName: htmlName, csx: csx, wrapperSX: wrapperSX, variant: variant, placeholder: placeholder, children: children, inputMode: "numeric" })));
};
exports.DateInput = DateInput;
